import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { Nav, Tab } from "react-bootstrap";
import AttachmentFile from "../../asset/images/Vector.svg";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { IPO_Master } from "../../Configuration/API_URL";
import { toast } from "react-toastify";
import RoundLoader from "../../Components/Common/RoundRingLoader";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { useDebounce } from "../../Components/useDebounce";
import axiosInstance, { axiosMultipartInstance } from "../../CommonMethhods/axiosInstance";

function IPOMaster() {
  const storeToken = localStorage.getItem("ssoToken");
  const [ipoMasterDetail, setIpoMasterDetail] = useState([]);
  const [mainError, setMainError] = useState(false);
  const [inputSearch, setInputSearch] = useState("");
  const [loader, setLoader] = useState({
    mainLoader: false,
    excelLoader: false,
    submitLoader: false,
  });
  const [yearDynamic, setYearDynamic] = useState("2024");

  const MAX_FILE_SIZE = 1048576 * 5; //100KB
  function isValidSize(fileName) {
    if (fileName && fileName.length > 0) {
      if (fileName[0].size <= MAX_FILE_SIZE) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  const ipoFormSchema = Yup.object().shape({
    inputFile: Yup.string(),
    fileUpload: Yup.mixed()
      .test(
        "Added Image",
        "*Mandatory to select File",
        (value) => value.length > 0
      )
      .test("is-valid-size", "*Please select file less than 5 MB", (value) => {
        return isValidSize(value);
      }),
    monthDropDown: Yup.string().required("*Please select month"),
  });

  const debouncedValue = useDebounce(inputSearch, 1000);
  
      useEffect(() => {
          handleOnChangeForSearchAp(debouncedValue);
      }, [debouncedValue]);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    getValues,
    reset,

    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(ipoFormSchema),
  });

  const handleFileUpload = (e) => {
    setValue("inputFile", getValues("fileUpload"));
    document.getElementById("uploadFile").value = e.target.value.replace(
      "C:\\fakepath\\",
      ""
    );
  };

  const IPODataUpload = async (data) => {
    try {
      const formData = new FormData();
      formData.append("fileData", data.fileUpload[0]);
      formData.append("type", "ipo");
      formData.append("Month", data.monthDropDown);
      formData.append("Year", yearDynamic);

      const declarationData = await axiosMultipartInstance.post(
        IPO_Master.UploadIpoMaster_URL,
        formData,

        // {
        //   headers: {
        //     "Content-Type": "multipart/form-data",
        //     Authorization: `Bearer ${storeToken}`,
        //   },
        // }
      );
      const res = declarationData?.data;
      if (res?.status === 0) {
        toast.success(res?.data);
        getIPOMasterList("grid", "");
        clearErrors();
        reset();
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message);
    } finally {
      setLoader({ submitLoader: false });
    }
  };

  const OnFinalSubmit = (data) => {
    IPODataUpload(data);
  };

  const handleReset = () => {
    clearErrors();
    reset();
    document.getElementById("uploadFile").value = "";
  };

  const getIPOMasterList = async (viewType = "grid", value = "") => {
    if (viewType === "grid") {
      setLoader({ mainLoader: true });
    }
    if (viewType === "excel") {
      setLoader({ excelLoader: true });
    }
    let payloadValue = { fileType: viewType, search: value, type: "ipo" };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getApList = await axiosInstance.post(
        IPO_Master.GetMasterIpoData_URL,

        `"${encPayload}"`,
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: `Bearer ${storeToken}`,
        //     reserv: 1,
        //   },
        // }
      );

      const res = ApiResDecrypt(getApList?.data);
      if (res?.status === 0) {
        setMainError(false);
        if (viewType === "grid") {
          setIpoMasterDetail(res?.data?.ipoList);
        } else if (viewType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
      } else {
        setIpoMasterDetail([]);
        if (viewType === "grid") {
          setMainError(res?.message);
        } else if (viewType === "excel") {
          toast.error(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      if (viewType === "grid") {
        setMainError(error?.message);
        setIpoMasterDetail([]);
      } else if (viewType === "excel") {
        toast.error(error?.message);
      }
    } finally {
      setLoader({
        mainLoader: false,
        excelLoader: false,
        submitLoader: false,
      });
    }
  };

  useEffect(() => {
    if (inputSearch === "") {
      getIPOMasterList("grid", "");
    }
  }, [inputSearch]);

  const handleOnChangeForSearchAp = (data) => {
    // e.target.value = e.target.value.toUpperCase();
    // setInputSearch(e.target.value);
    if(data){
    getIPOMasterList("grid", data);
    }
  };

  const handleDownloadClick = (e) => {
    getIPOMasterList(e.target.value, inputSearch);
  };

  useEffect(() => {
    const d = new Date();
    let year = d.getFullYear();
    setYearDynamic(year);
  }, [yearDynamic]);

  return (
    <>
      <Header portal={"RM"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="familyIpo-master-wrapper">
        <form onSubmit={handleSubmit(OnFinalSubmit)}>
          <div className="card-box">
            <div className="row input-field-wrapper">
              <div className="col-md-3 col-sm-3 col-12">
                <div className="form-group">
                  <label className="form-label">Upload File:</label>
                  <div
                    className={`custom-upload  ${
                      errors.fileUpload ? "invalid" : ""
                    }`}
                  >
                    <input
                      id="uploadFile"
                      className="f-input"
                      readOnly
                      {...register("inputFile")}
                    />
                    <div className="fileUpload btn btn--browse">
                      <img src={AttachmentFile} alt="attachment" className />
                      <span>Browse File</span>
                      <input
                        type="file"
                        className="upload"
                        accept=".csv,.xlsx,.xlsm,.xlsb,.xltx,.xls"
                        {...register("fileUpload", {
                          onChange: (e) => {
                            handleFileUpload(e);
                          },
                        })}
                      />
                    </div>
                  </div>
                  <div className="ErrorMsg">{errors?.fileUpload?.message}</div>
                </div>
              </div>
              <div className="col-md-2 col-sm-2 col-6">
                <div className="form-group">
                  <label className="form-label">Month:</label>
                  <select
                    className={`report-custom-select  ${
                      errors.monthDropDown ? "invalid" : ""
                    }`}
                    {...register("monthDropDown")}
                  >
                    <option value="">--Select Month--</option>
                    <option value="1">January</option>
                    <option value="2">February</option>
                    <option value="3">March </option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                  <div className="ErrorMsg">
                    {errors.monthDropDown?.message}
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-sm-2 col-6">
                <div className="form-group">
                  <label className="form-label">Year:</label>
                  <select className="report-custom-select">
                    <option value={yearDynamic} selected>
                      {yearDynamic}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="save-reset-btn">
              <button type="submit" className="margin-save-btn">
                {loader.submitLoader ? (
                  <div className="download-loader">
                    <RoundLoader h={"20"} />
                  </div>
                ) : (
                  "Submit"
                )}
              </button>
              <button
                type="button"
                className="margin-reset-btn"
                onClick={handleReset}
              >
                Cancel
              </button>
            </div>
            <div>
              <div className="master-table-wrapper">
                <div className="tableHead">
                  <h4 className="master-title">Master Table</h4>
                  <button
                    type="button"
                    className="downloadBtn"
                    value="excel"
                    onClick={(e) => handleDownloadClick(e)}
                  >
                    {loader.excelLoader ? (
                      <div className="download-loader">
                        <RoundLoader h={"20"} />
                      </div>
                    ) : (
                      "Download"
                    )}
                  </button>
                </div>

                <div className="tab-content" id="myTabContent">
                  <Tab.Container id="left-tabs-example" activeKey="IPOMaster">
                    {/* page tabs */}
                    <div className="d-flex justify-content-between mt-2">
                      <div className="d-flex">
                        <Nav variant="nav tabs page-tabs">
                          <li className="nav-item">
                            <Nav.Link eventKey="IPOMaster">IPO Master</Nav.Link>
                          </li>
                        </Nav>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          name="search-text"
                          id="SearchInput"
                          className="input-st mt-3 h-75"
                          placeholder="Search here..."
                          value={inputSearch}
                          autoComplete="off"
                          onChange={(e) => {
                            setInputSearch(e?.target?.value?.toUpperCase())
                            // handleOnChangeForSearchAp(e);
                          }}
                          onInput={(e) => {
                            const start = e.target.selectionStart;
                            const end = e.target.selectionEnd;
                            let input = e.target.value;
                            input = input
                                .toUpperCase()
                                .replace(/[^A-Z0-9\s]/g, "")
                                .replace(/\s+/g, " ")
                                .trimStart()
                                .slice(0, 100);

                            e.target.value = input;
                            e.target.setSelectionRange(start, end);
                            
                        }}
                        />
                      </div>
                    </div>
                    {/* page tabs end */}

                    <div className="for-grid-section">
                      <Tab.Content>
                        <Tab.Pane eventKey="IPOMaster">
                          <div
                            className="scroll-table family_table"
                            id="for-scroll-left"
                          >
                            <table className="table">
                              <thead>
                                <tr>
                                  <th scope="col">IPO Name</th>
                                  <th scope="col">Client Code</th>
                                  <th scope="col">No of Shares</th>
                                  <th scope="col">Value</th>
                                </tr>
                              </thead>

                              <tbody>
                                {loader.mainLoader ? (
                                  <div className="loader-alignment">
                                    <Loader />
                                  </div>
                                ) : (
                                  ipoMasterDetail &&
                                  ipoMasterDetail?.map((value, item) => {
                                    let {
                                      clientCode,
                                      ipoName,
                                      noOfShares,
                                      values,
                                    } = value;
                                    return (
                                      <tr key={item}>
                                        <td>{ipoName}</td>
                                        <td>{clientCode}</td>
                                        <td>{noOfShares}</td>
                                        <td>{values}</td>
                                      </tr>
                                    );
                                  })
                                )}
                              </tbody>
                            </table>
                            {mainError && (
                              <div className="report-error-message">
                                {noDataFound(mainError)}
                              </div>
                            )}
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </div>
                  </Tab.Container>
                </div>
              </div>
            </div>
          </div>
        </form>
      </main>
    </>
  );
}
export default IPOMaster;
